<div class="dashboard-timezone">
  <mat-form-field appearance="outline" floatLabel="always" id="vi_timezone_dropdown_dashboard">
    <mat-select
      [(ngModel)]="currentZoneDetails"
      (selectionChange)="onTimezoneChange()"
      class="timezone-field"
      hideSingleSelectionIndicator="true">
      <mat-option *ngFor="let zone of timezoneList" [value]="zone">
        {{ zone.label + ' ' + zone.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="all-chart-container">
  <div #graphChartContainer class="graph-chart-container">
    <mat-card class="no-link events-chart-card" *ngIf="!summaryLoader && !riskLoader; else chartLoader">
      <div class="main-chart" id="graph_chart">
        <div class="graph-content">
          <mat-card-header class="graph-header">
            <mat-card-title class="graph-title"
              ><span class="total-event-title">Total events: {{ totalEvents }} </span>
              <mat-card-subtitle *ngIf="chartTimeLine?.length" class="sub-label">({{ chartTimeLine }})</mat-card-subtitle>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="line-chart-container">
            <div class="event-chart" *ngIf="totalEvents; else no_data">
              <div
                *ngIf="isFullScreen"
                class="custom-highcharts custom-highcharts-container custom-highcharts-legend-box custom-highcharts-line-series full-screen">
                <highcharts-chart
                  [Highcharts]="Highcharts"
                  [options]="eventLineChartOption"
                  [(update)]="updateEventLineChart"
                  class="custom-highcharts-container"></highcharts-chart>
              </div>
              <div *ngIf="!isFullScreen">
                <highcharts-chart
                  [Highcharts]="Highcharts"
                  [options]="eventLineChartOption"
                  [(update)]="updateEventLineChart"></highcharts-chart>
              </div>
            </div>
          </mat-card-content>
        </div>
        <div class="event-status-line-container">
          <div [ngClass]="[isFullScreen ? 'full-screen-vertical-line' : 'vertical-line']" *ngIf="totalEvents"></div>
          <div [ngClass]="[isFullScreen ? 'full-screen-event-status-container' : 'event-status-container']" *ngIf="totalEvents">
            <div class="event-status-row" *ngIf="validCount !== undefined && validCount !== null">
              <mat-icon svgIcon="check" class="status-icon valid-icon"></mat-icon>
              <div class="event-status-count">{{ validCount }}<span class="event-status-text">Valid</span></div>
            </div>
            <div class="event-status-row" *ngIf="invalidCount !== undefined && invalidCount !== null">
              <mat-icon svgIcon="check" class="status-icon invalid-icon"></mat-icon>
              <div class="event-status-count">{{ invalidCount }}<span class="event-status-text">Invalid</span></div>
            </div>
            <div class="event-status-row" *ngIf="notReviewedCount !== undefined && notReviewedCount !== null">
              <mat-icon svgIcon="close" class="status-icon not-reviewed-icon"></mat-icon>
              <div class="event-status-count">{{ notReviewedCount }}<span class="event-status-text">Not reviewed</span></div>
            </div>
            <div class="event-status-row" *ngIf="excludeCount !== undefined && excludeCount !== null && isAdmin">
              <mat-icon svgIcon="remove" class="status-icon exclude-icon"></mat-icon>
              <div class="event-status-count">{{ excludeCount }}<span class="event-status-text">Excluded</span></div>
            </div>
          </div>
        </div>
      </div>
      <mat-icon svgIcon="close" *ngIf="isFullScreen" class="close-icon" (click)="exitFullScreen()"></mat-icon>
      <div class="side-icon" *ngIf="totalEvents">
        <mat-icon
          svgIcon="hamburger"
          *ngIf="!isFullScreen"
          class="icon hamburger-icon"
          [class.active]="isMenuOpen"
          (click)="toggleMenu()"
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"></mat-icon>
        <mat-menu class="download-list" #menu="matMenu" (closed)="onMenuClose()">
          <div class="download-options" mat-menu-item (click)="downloadAsPngJpeg('png'); closeMenu()">
            <span class="download-menu">Download PNG image</span>
          </div>
          <div class="download-options" mat-menu-item (click)="downloadAsPngJpeg('jpeg'); closeMenu()">
            <span class="download-menu">Download JPEG image</span>
          </div>
          <div class="download-options" mat-menu-item (click)="downloadAsPdf(); closeMenu()">
            <span class="download-menu">Download PDF document</span>
          </div>
        </mat-menu>
        <mat-icon svgIcon="expand-1" *ngIf="!isFullScreen" class="icon fullscreen-icon" (click)="toggleFullScreen()"></mat-icon>
      </div>
      <ng-template #no_data>
        <p class="align-center" id="vi_dashboard_gateways_no_data">No chart data is available</p>
      </ng-template>
    </mat-card>
    <ng-template #chartLoader>
      <mat-card class="global-event-loader">
        <mat-card-content class="doughnut-chart-loader"> <app-spinner></app-spinner> </mat-card-content>
      </mat-card>
    </ng-template>
  </div>
  <div class="risk-chart-container">
    <mat-card class="no-link" id="vi_total_violation_chart_dashboard" *ngIf="!summaryLoader && !riskLoader; else riskEventsLoader">
      <mat-card-header class="event-header">
        <mat-card-title class="risk-event-header" id="vi_total_violation_chart_dashboard_header">At risk behaviour </mat-card-title>
        <mat-card-subtitle *ngIf="chartTimeLine?.length" class="sub-label risk-chart">({{ chartTimeLine }})</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="chart-container" *ngIf="totalEvents; else no_event_status">
        <div
          class="risk-status-button-group"
          *ngIf="
            (enableRedzoneRiskStatus && totalRedZoneEvents !== null && totalRedZoneEvents > 0) ||
            (enablePpeRiskStatus && totalPpeEvents !== null && totalPpeEvents > 0) ||
            (enableCatwalkRiskStatus && totalCatwalkEvents !== null && totalCatwalkEvents > 0) ||
            (enablePiperackRiskStatus && totalPiperackEvents !== null && totalPiperackEvents > 0)
          ">
          <div
            *ngIf="enableRedzoneRiskStatus && totalRedZoneEvents !== null && totalRedZoneEvents > 0"
            class="btn"
            [ngClass]="{ 'selected-btn': selectedWf === 'redzone' }"
            (click)="onRiskEventClick('redzone')">
            <span class="btn-text">Red zone - {{ totalRedZoneEvents }}</span>
          </div>
          <div
            *ngIf="enablePpeRiskStatus && totalPpeEvents !== null && totalPpeEvents > 0"
            class="btn"
            [ngClass]="{ 'selected-btn': selectedWf === 'ppe' }"
            (click)="onRiskEventClick('ppe')">
            <span class="btn-text">PPE - {{ totalPpeEvents }}</span>
          </div>
          <div
            *ngIf="enableCatwalkRiskStatus && totalCatwalkEvents !== null && totalCatwalkEvents > 0"
            class="btn"
            [ngClass]="{ 'selected-btn': selectedWf === 'catwalk' }"
            (click)="onRiskEventClick('catwalk')">
            <span class="btn-text">Catwalk - {{ totalCatwalkEvents }}</span>
          </div>
          <div
            *ngIf="enablePiperackRiskStatus && totalPiperackEvents !== null && totalPiperackEvents > 0"
            class="btn"
            [ngClass]="{ 'selected-btn': selectedWf === 'piperack' }"
            (click)="onRiskEventClick('piperack')">
            <span class="btn-text">Piperack - {{ totalPiperackEvents }}</span>
          </div>
        </div>
        <div class="risk-chart-tab-group">
          <ng-container *ngFor="let tabs of riskDataWfList">
            <div class="" *ngIf="tabs.value !== null && tabs.value && tabs.value > 0">
              <div class="risk-chart-tab">
                <p class="tab-value">{{ tabs.value }}</p>
                <p class="tab-text">{{ truncateTabName(tabs.name) }}</p>
              </div>
            </div>
          </ng-container>
          <div class="risk-status-error-message" *ngIf="isRiskStatusEmpty">
            <mat-error>Please select risk event type corresponding to {{ setLabel(selectedWf) }}</mat-error>
          </div>
        </div>
      </mat-card-content>
      <ng-template #no_event_status>
        <p class="align-center-no-data" id="vi_analytics_risk_event_no_data">No data available</p>
      </ng-template>
    </mat-card>
    <ng-template #riskEventsLoader>
      <mat-card class="global-event-loader">
        <mat-card-content class="doughnut-chart-loader"> <app-spinner></app-spinner> </mat-card-content>
      </mat-card>
    </ng-template>
  </div>

  <div class="redzone-telemetry-section">
    <mat-card
      class="no-link"
      id="vi_redzone_telemetry_section"
      *ngIf="!showRedZoneTelemetryLoader && redZoneTelemetryDetails && redZoneTelemetryDetails.length > 0 && !showNoTrespassingMessage">
      <mat-card-header class="redzone-telemetry-header">
        <mat-card-title class="redzone-telemetry-header-title" id="vi_redzone_telemetry_header">Red Zone Telemetry </mat-card-title>
        <mat-card-subtitle *ngIf="redZoneTelemetryTimeline?.length" class="sub-label rz-t-timeline"
          >({{ redZoneTelemetryTimeline }})</mat-card-subtitle
        >
        <button
          slb-button
          class="redzone-telemetry-csv-btn"
          id="vi_redzone-telemetry_csv_download"
          [disabled]="isRedZoneTelemetryCsvDownloading"
          (click)="downloadCSV()">
          <mat-icon svgIcon="csv" [slbTooltip]="'Download CSV'"></mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="chart-container">
        <div class="risk-chart-tab-group">
          <ng-container *ngFor="let kpi of redZoneTelemetryDetails">
            <div class="">
              <div class="risk-chart-tab">
                <p class="tab-value">{{ kpi.value }}</p>
                <p class="tab-text">{{ kpi.title }}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card
      class="global-event-loader"
      *ngIf="!redZoneTelemetryDetails || redZoneTelemetryDetails.length === 0 || showNoTrespassingMessage">
      <mat-card-header class="redzone-telemetry-header" *ngIf="!showRedZoneTelemetryLoader">
        <mat-card-title class="redzone-telemetry-header-title" id="vi_redzone_telemetry_header">Red Zone Telemetry </mat-card-title>
        <mat-card-subtitle *ngIf="redZoneTelemetryTimeline?.length" class="sub-label rz-t-timeline"
          >({{ redZoneTelemetryTimeline }})</mat-card-subtitle
        >
        <button slb-button class="redzone-telemetry-csv-btn" id="vi_redzone-telemetry_csv_download_no_data" [disabled]="true">
          <mat-icon svgIcon="csv" [slbTooltip]="'Download CSV'"></mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content *ngIf="showRedZoneTelemetryLoader"> <app-spinner></app-spinner> </mat-card-content>
      <mat-card-content
        *ngIf="
          redZoneTelemetryAPIResp &&
          !redZoneTelemetryAPIResp.redZoneExposureTime &&
          !maxCamAndWorkflowLimitReached &&
          !showRedZoneTelemetryLoader &&
          !showNoTrespassingMessage
        ">
        <p class="align-center-long-message">No red zone telemetry data received for the selected duration</p>
      </mat-card-content>
      <mat-card-content *ngIf="showNoTrespassingMessage && !showRedZoneTelemetryLoader"
        ><p class="align-center-long-message">No trespassing seen at the red zone area for this respective site</p></mat-card-content
      >
      <mat-card-content *ngIf="maxCamAndWorkflowLimitReached && !showRedZoneTelemetryLoader">
        <p class="align-center-long-message">Please select single camera and redzone workflow to view red zone telemetry.</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
